import Big from 'big.js'

import type { ExpenseListItem, ServerExpenseListItem } from '../expense/types'



export function parseExpensesList(source: ServerExpenseListItem[]): ExpenseListItem[] {
	return source.map((expense) => ({
		...expense,
		subtotal: Big(expense.subtotal),
		discount: Big(expense.discount),
		tax: Big(expense.tax),
		total: Big(expense.total),
		amount_paid: Big(expense.amount_paid),
		amount_due: Big(expense.amount_due),
		service_charge: Big(expense.service_charge)
	}))
}